import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AdminMain from '../../presentation/section/admin-page/AdminMain';

const Admin = (props) => {
  const history = useHistory();

  useEffect(() => {
    if(props.currentRole != 'ROLE_ADMIN'){
      history.goBack();
    }
  },[])

  return (
    <AdminMain />
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser,
  currentRole : state.AuthManager.status.currentRole
})

export default connect(mapStateToProps) (Admin);